import React from "react";
import "./loader.scss";

const Loader = () => (
  <div className="fallback-spinner">
    <span className="loader"></span>
  </div>
);
export default Loader;
